import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "font-awesome/css/font-awesome.min.css";
import FormSelect from "react-bootstrap/Form";
import "../../../pages/admin/admin_assets/css/Customer.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import config from '../../../config/config.js';

const MyVerticallyCenteredModal = (props) => {
  const [category, setCategory] = useState(""); // State for the category (choice, welcome, etc.)
  const [questionText, setQuestionText] = useState(""); // State for the actual question text
  const [otherValue, setOtherValue] = useState("choice");
  const [keyIn, setKeyIn] = useState("");

  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [qTitle, setQTitle] = useState("");
  const [qDesc, setQDesc] = useState("");

  useEffect(() => {
    if (props.value) {
      setCategory(props.value);  // Set the category from the parent
      setOtherValue(props.value);
      setKeyIn(props.value);
    }
  }, [props.value]);

  const handleSubmit = () => {
  let tableName = "";

  if (props.value === 1) {
    tableName = "byb_customer_questions";
  } else if (props.value === 2) {
    tableName = "byb_employee_questions";
  } else if (props.value === 3) {
    tableName = "byb_partner_questions";
  } else if (props.value === 4) {
    tableName = "byb_investor_questions";
  }

  const payload = {
    table: tableName,
    q_type: category,
    question_status: "Active",
  };

  if (category === "choice") {
    payload.question = questionText;
    payload.option1 = option1;
    payload.option2 = option2;
    payload.option3 = option3;
    payload.option4 = option4;
  } else if (category === "welcome" || category === "end") {
    // First, check if a welcome or end question already exists
    fetch(`${config.API_BASE_URL}/check_question_exists.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        table: tableName,
        q_type: category,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.exists) {
          alert(`${category.charAt(0).toUpperCase() + category.slice(1)} screen already exists.`);
        } else {
          payload.q_title = qTitle;
          payload.q_desc = qDesc;

          // Proceed with inserting the question
          fetch(`${config.API_BASE_URL}/add_question.php`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.success) {
                toast.success(`Question added successfully!`);
                window.location.reload();
              } else {
                toast.error("Error adding question: " + data.message);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              toast.error("An error occurred while adding the question.");
            });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An error occurred while adding the question.");
      });
  } else if (category === "key-question") {
    payload.question = questionText;
  }

  // If it's not welcome or end, just proceed with submission
  if (category !== "welcome" && category !== "end") {
    fetch(`${config.API_BASE_URL}/add_question.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          toast.success(`Question added successfully!`);
          window.location.reload();
        } else {
          toast.error("An error occurred while adding the question.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An error occurred while adding the question.");
      });
  }
};


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="question-popup"
    >
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <Modal.Body className="survey_popup">
        <h4>Add New Question</h4>
        <div className="category_label">
          <FormSelect.Label htmlFor="question">Category</FormSelect.Label>
          <FormSelect.Select
            aria-label="Default select example"
            className="form-control"
            value={category}
            onChange={(e) => setCategory(e.target.value)} // Update category
          >
            <option value="">Select Category</option>
            <option value="choice">Choice-Based Question</option>
            <option value="welcome">Welcome Screen</option>
            <option value="end">End Screen</option>
            <option value="key-question">Key-In Question</option>
          </FormSelect.Select>
        </div>

        {category === "choice" && (
          <div className="add_formspace others_sec">
            <Form.Label>Question</Form.Label>
            <Form.Control
              type="text"
              value={questionText}  // Bind to questionText state
              onChange={(e) => setQuestionText(e.target.value)}  // Update question text
            />
            <Form.Label>Option 1</Form.Label>
            <Form.Control
              type="text"
              value={option1}
              onChange={(e) => setOption1(e.target.value)}
            />
            <Form.Label>Option 2</Form.Label>
            <Form.Control
              type="text"
              value={option2}
              onChange={(e) => setOption2(e.target.value)}
            />
            <Form.Label>Option 3</Form.Label>
            <Form.Control
              type="text"
              value={option3}
              onChange={(e) => setOption3(e.target.value)}
            />
            <Form.Label>Option 4</Form.Label>
            <Form.Control
              type="text"
              value={option4}
              onChange={(e) => setOption4(e.target.value)}
            />
            <div className='submit_btns d-line d-lg-flex'>
              <button className="exportbutton text-white" onClick={handleSubmit}>
                Add Question
              </button>
              <button className="exportbutton text-danger" onClick={props.onHide}>
                Cancel
              </button>
            </div>
          </div>
        )}

        {(category === "welcome" || category === "end") && (
          <div className="add_formspace">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              value={qTitle}
              onChange={(e) => setQTitle(e.target.value)}
            />
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              value={qDesc}
              onChange={(e) => setQDesc(e.target.value)}
            />
            <div className='submit_btns d-line d-lg-flex'>
              <button className="exportbutton text-white" onClick={handleSubmit}>
                Add Question
              </button>
              <button className="exportbutton text-danger" onClick={props.onHide}>
                Cancel
              </button>
            </div>
          </div>
        )}

        {category === "key-question" && (
          <div className="add_formspace">
            <Form.Label>Question</Form.Label>
            <Form.Control
              type="text"
              value={questionText}
              onChange={(e) => setQuestionText(e.target.value)}
            />
           <div className='submit_btns d-line d-lg-flex'>
              <button className="exportbutton text-white" onClick={handleSubmit}>
                Add Question
              </button>
              <button className="exportbutton text-danger" onClick={props.onHide}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

const CreateNewQuestion = ({ value }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <p onClick={() => setModalShow(true)} className="exportbutton">
        <i className="bi bi-plus-circle"></i> Create New Question
      </p>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        value={value}
      />
      <ToastContainer />
    </>
  );
};

export default CreateNewQuestion;
